import React, {useState} from "react";
import './classCards.scss';
import ToggleSwitch from "../../ToggleSwitch";
import DeleteAlert from "../../DeleteAlert";
import * as appRoutes from "../../../../routes/routeConstants/appRoutes";
import {withRouter,generatePath} from "react-router-dom";
import ClassForm from "../ClassForm";
import CardMenu from "../CardMenu";
import ClassroomService from "../../../../services/CourseServices/ClassroomService/classroom.service";

const ClassCards = (props:any) => {

    const {classes,refreshList, currentPageNumber, boardId} = props;

    const [formVisible,setFormVisible] = useState<boolean>(false);
    const [deleteVisible,setDeleteVisible] = useState<boolean>(false);
    const [currentClass,setCurrentClass] = useState<any>('');

    const handleStatusToggle = (classId:number,checked:boolean) => {
        ClassroomService.updateClassroom(classId,
            {class_room:{is_active: checked}},
            ()=>{
                refreshList(currentPageNumber)
            },
            ()=>{},
            ()=>{},
        ).then()
    }

    const handleDelete = () => {
        ClassroomService.deleteClassroom(currentClass.id,
            ()=>{
                refreshList(currentPageNumber)
                setDeleteVisible(false)
            },
            ()=>{},
            ()=>{},
        ).then()
    }

    return(
        <div>
            <ClassForm title='Create New Class'
                       visible={formVisible}
                       setVisible={setFormVisible}
                       data={currentClass}
                       refreshList={refreshList}
                       currentPageNumber={currentPageNumber}
                       boardId={boardId}
            />
            <DeleteAlert title={currentClass?.name}
                         detail={(currentClass?.numberOfSubjects || 0 )+' Subjects'}
                         visible={deleteVisible}
                         setVisible={setDeleteVisible}
                         deleteText='class'
                         deleteWarning='This class will be deleted permanently'
                         handleDelete={handleDelete}
            />
            {classes.map((course:any) =>
                <div className='class__card' key={course.id} onClick={()=>{
                    props.history.push(generatePath(appRoutes.COURSE_SUBJECTS,{
                        boardName: props.match.params.boardName,
                        boardId: props.match.params.boardId,
                        className:course.name,
                        classId: course.id
                    }))
                }}>
                    <div className='course__details'>
                        <div className='course__acronym'>{course.name}</div>
                        <div className='course__title'>
                            <span className='class__subjects'>{course.subjectCount || 0} Subjects</span>
                            <span className='class__fees'> <span className='details-separator'/>{course.amountRupees}</span>
                            <span><span className="details-separator" />{" "}ID: {course.id}</span>
                        </div>
                    </div>
                    <div className='course__toggle' onClick={(event)=>event.stopPropagation()}>
                        <ToggleSwitch checked={course.isActive}
                                      handleChange={(checked)=>handleStatusToggle(course.id,checked)}
                        />
                    </div>
                    <div className='class-menu-trigger' onClick={(event)=>{
                        event.stopPropagation();
                        setCurrentClass(classes.filter((obj:any) => obj.id === course.id )[0])
                    }}>
                        <CardMenu menuText='Class'
                                  handleEdit={setFormVisible}
                                  handleDelete={setDeleteVisible}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default withRouter(ClassCards);
